export type WeboramaRequestType = {
    [key: string]: string;
};
export const weboramaRequests: WeboramaRequestType = {
    consultation: 'consultation',
    buy: 'btn_buy',
    crmId: 'CRM_ID',
};
